import { createSlice } from '@reduxjs/toolkit';
import { RESET_ALL_REDUCERS } from 'actions';

const INITIAL_STATE = {
    defaultRoute: [],
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState: INITIAL_STATE,
    reducers: {
        setDefaultRoute: (state, action) => {
            state.defaultRoute = action.payload ?? [];
        },
    },
    extraReducers: (builder) => {
        // This slice is persisted (sessionStorage) and survives a new-token page
        // load in the same tab; without this reset the previous link's route
        // list leaks into the next session and can skip its pre-identity steps.
        builder.addCase(RESET_ALL_REDUCERS, () => ({ ...INITIAL_STATE }));
    },
});

export const { setDefaultRoute } = navigationSlice.actions;

export default navigationSlice.reducer;
